import React from 'react';
import PropTypes from 'prop-types';

const ReturnHome = props => {

    const { bckgColor, urlEspecial } = props;

    return (
        <section className="my-4 text-center">
            <a className="btn border border-white shadow-sm fw-bolder text-white btn-return" style={{ background: bckgColor }} href={urlEspecial}>INICIO</a>
        </section>
    )
}

export default ReturnHome;

ReturnHome.propTypes = {
    bckgColor: PropTypes.string.isRequired,
    urlEspecial: PropTypes.string.isRequired
}
